import styled from "styled-components";
import { setThemeColor } from "../../setThemeColor";
import { setTextColor } from "../../setTextColor";
import { typographyMixin } from "../../typography";
import { BadgeProps } from "./Badge.types";

type StyledBadgeProps = Pick<BadgeProps, "theme" | "variant">;

export const StyledBadge = styled.div<StyledBadgeProps>`
  ${typographyMixin}
  font-weight: 500;
  display: inline-block;
  padding: 0.2rem 0.3rem;
  margin-right: 1px;
  border-radius: 2px;

  // sets color based on theme
  background-color: ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.textOnPrimaryColor};

  // sets color if a variant is passed by variant name
  background-color: ${(props) => props.variant && props.theme[props.variant]};
  color: ${(props) => props.variant && "#fff"};
`;
